import { forwardRef } from 'react'
import { Separator } from '@/components/ui/separator'
import { useGetCountries } from '@/features/experience-shell/queries/use-get-countries'
import type { RemapExperienceForViewOnly } from '@/features/experience-view-only/types'
import { useTranslation } from '@/translations/i18n'
import { AnswerField, Content } from './atoms'

export const LocationStep = forwardRef<
	HTMLDivElement,
	{ experience: RemapExperienceForViewOnly }
>(({ experience }, ref) => {
	const { t } = useTranslation()
	const countriesQuery = useGetCountries()
	const countryName = countriesQuery.data?.data.find(
		(country) =>
			country.code === experience.expertise.answers.country_region?.answer
	)?.name
	return (
		<div className='flex w-full flex-col' ref={ref}>
			<Content margin={6} title={t('experience_shell:step_location')}>
				<AnswerField
					hasValue={!!countryName}
					labelTitle={t('experience_shell:country_region')}
					value={countryName}
				/>
				<AnswerField
					hasValue={
						!!experience.expertise.answers.location_address?.answer
					}
					labelTitle={t('experience_shell:street_address')}
					value={
						experience.expertise.answers.location_address?.answer
					}
				/>
				<AnswerField
					hasValue={
						!!experience.expertise.answers.location_address_extras
							?.answer
					}
					labelTitle={t('experience_shell:apt_suite')}
					value={
						experience.expertise.answers.location_address_extras
							?.answer
					}
				/>

				<AnswerField
					hasValue={
						!!experience.expertise.answers.location_state?.answer
					}
					labelTitle={t('experience_shell:state_territory')}
					value={experience.expertise.answers.location_state?.answer}
				/>
				<AnswerField
					hasValue={
						!!experience.expertise.answers.location_zip?.answer
					}
					labelTitle={t('experience_shell:zip_code')}
					value={experience.expertise.answers.location_zip?.answer}
				/>
			</Content>
			<Separator orientation='horizontal' />

			<Content margin={6}>
				<AnswerField
					hasValue={
						!!experience.expertise.answers.meeting_point_name
							?.answer
					}
					labelTitle={t('experience_view_only:location_name')}
					value={
						experience.expertise.answers.meeting_point_name?.answer
					}
				/>
			</Content>
		</div>
	)
})

LocationStep.displayName = 'LocationStep'
